import { UseFormReturn } from "react-hook-form";
import { MiModal } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { IPriceLevelResponse } from "@miplatform/types";
import { useTheme } from "@mui/material";

export function UpdateDependentModal({
  open,
  form,
  priceLevels,
  closeModal,
  handleUpdatePriceLevel,
  handleClosePriceLevelForm,
}: UpdateDependentModalProps) {
  const theme = useTheme();
  const { watch, getValues } = form;
  const { name, id } = watch();

  const handleUpdate = (updateDependencies = false) => {
    const data = getValues();
    const successText = updateDependencies
      ? `${data.name} and its dependent(s) price level were updated successfully.`
      : "";
    handleUpdatePriceLevel({ ...data, updateDependencies }, successText);
    handleClosePriceLevelForm();
    closeModal();
  };

  const actions = [
    {
      title: "Cancel",
      variant: BUTTON_VARIANTS.TEXT,
      color: BUTTON_COLORS.BLACK,
      onClick: () => {
        closeModal();
      },
    },
    {
      title: "Don't Update Dependents",
      variant: BUTTON_VARIANTS.OUTLINED,
      onClick: () => handleUpdate(),
    },
    {
      title: "Update Dependents",
      variant: BUTTON_VARIANTS.CONTAINED,
      onClick: () => handleUpdate(true),
    },
  ];

  const dependentPriceLevels = priceLevels
    .filter((level) => level.parentId === id)
    .map((level) => level.name)
    .join(", ");

  return (
    <MiModal
      open={open}
      closeModal={closeModal}
      width={470}
      actions={actions}
      title="Update Dependent Price Levels?"
      description={
        <>
          You're editing{" "}
          <span
            style={{
              color: theme.palette.primary.main,
              fontWeight: theme.fontWeight.semiBold,
            }}
          >
            {name}
          </span>{" "}
          price level, which affects the following price level(s):{" "}
          <span
            style={{
              color: theme.palette.primary.main,
              fontWeight: theme.fontWeight.semiBold,
            }}
          >
            {dependentPriceLevels}.
          </span>{" "}
          Choose how you'd like dependent levels to behave:
        </>
      }
    />
  );
}

interface UpdateDependentModalProps {
  open: boolean;
  form: UseFormReturn<IPriceLevelResponse>;
  priceLevels: IPriceLevelResponse[];
  closeModal: () => void;
  handleUpdatePriceLevel: (
    data: IPriceLevelResponse,
    successText?: string
  ) => void;
  handleClosePriceLevelForm: () => void;
}
